import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { ProductPreview } from 'src/app/content-blocks/models';
import { staticShopSettings } from 'src/app/shop/settings';
import { Product, Option } from '../../../shop/models';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductCardComponent {
  @Input() product!: Product | undefined;
  @Input() productPreview?: ProductPreview;
  @Input() collectionHandle?: string;
  @Output() addToCart = new EventEmitter<Product>();
  @Input() showSlider = true;
  @Input() showVariantImages = false;

  @Input() sizes?:
    | {
        xs?: number;
        sm?: number;
        md?: number;
        lg?: number;
        xl?: number;
        xxl?: number;
      }
    | null
    | undefined;

  constructor(private cd: ChangeDetectorRef) {}

  collectionsAsText(collections: any) {
    return collections.map((a: any) => a.title).join(', ');
  }

  get colorCodes() {
    const colors = this.product?.variants
      .map(variant => variant.metafields?.filter(a => a?.key === 'color_code')?.[0]?.value)
      .filter(a => a);
    const uniqueColors = [...new Set(colors)];
    return uniqueColors;
  }

  getColorOption(): Option | null {
    const colorOption = this.product?.options?.filter(a => staticShopSettings.colorOptionNames.includes(a.name.toLowerCase()));
    if (colorOption?.length) {
      return colorOption[0];
    }
    return null;
  }

  getColorForOption(val: string) {
    const option = this.getColorOption();
    var relevantVariants = this.product?.variants.filter(variant =>
      variant.selectedOptions.some(a => a.name === option?.name && a.value === val)
    );
    return relevantVariants?.map(variant => variant.metafields?.filter(a => a?.key === 'color_code')?.[0]?.value).filter(a => a)?.[0];
  }

  getFirstColor() {
    const option = this.getColorOption();
    if (option?.values.length) {
      return { Color: option.values[0] };
    }
    return {};
  }
}
